import { invariant } from './errors';

/** Amount in Vietnamese đồng. VND has no minor unit, so money is always an integer. */
export type Vnd = number;

export const vnd = (amount: number): Vnd => {
  invariant(Number.isFinite(amount), 'Số tiền không hợp lệ');
  return Math.round(amount);
};

export const sumVnd = (amounts: readonly Vnd[]): Vnd => amounts.reduce((total, amount) => total + amount, 0);

export const formatVnd = (amount: Vnd): string => `${amount.toLocaleString('vi-VN')}đ`;

/** Compact form used on dashboards: 6.840.000 → "6,84 tr", 186.000 → "186k". */
export const formatVndCompact = (amount: Vnd): string => {
  if (Math.abs(amount) >= 1_000_000) {
    return `${(amount / 1_000_000).toLocaleString('vi-VN', { maximumFractionDigits: 2 })} tr`;
  }
  if (Math.abs(amount) >= 1_000) return `${Math.round(amount / 1_000)}k`;
  return formatVnd(amount);
};
